declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HCPService } from '../../../../services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ActorService } from '../../../../services/actor.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FDService } from '../../../../services/fd.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EditTreatmentCycleRequest, EditTreatmentCycleActvityRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { GenericProcPostRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { S_Methods } from '../../../../../../../src/app/ncs/models/actor/actor';

@Component({
  selector: 'ngbeditcycleactivities',
  templateUrl: './editcycleactivities.modal.html',
  styleUrls: ['./editcycleactivities.modal.scss']
})

export class NgbEditCycleActivitiesModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;

  @Input() ActivityTypeName: string;
  @Input() CounsellingActivityCode: number;
  @Input() ActivityName: string;
  @Input() Remarks: string;
  @Input() DisplayName: string;
  @Input() FormattedCode: string;
  @Input() PlanName: string;
  @Input() ActivityDate: Date;

    public ApiResData: ApiResponseModel;
    public isRequesting: boolean = false;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
        private actorservice: ActorService, private fdservice: FDService, private parserFormatter: NgbDateParserFormatter,
        private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
    private tosterservice: NGXToastrService, private spinner: NgxSpinnerService,
  ) { }

  public UpdatedRemarks: string;
  ngOnInit() {
    this.UpdatedRemarks = this.Remarks;
  }
  EditCycle() {
    var saveReq = new EditTreatmentCycleActvityRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40450;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.ActivityTypeName = this.ActivityTypeName;
    saveReq.CounsellingActivityCode = this.CounsellingActivityCode;
    saveReq.ActivityName = this.ActivityName;
    saveReq.Remarks = this.UpdatedRemarks;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40450;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
}
